import axios from 'axios'
import notifService from '../../services/notifService'

export const getAgreement = async (context, pagination) => {
  let res = await axios
    .get('/cms/agreements', {
      params: pagination
    })
    .then(response => {
      context.commit('getAgreement', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const countAgreement = async _context => {
  return await axios
    .get('/cms/agreements/count')
    .then(response => {
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }

      return false
    })
}

export const detailAgreement = async (_context, val) => {
  return await axios
    .get(`/cms/agreements/detail/${val}`)
    .then(response => {
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return null
    })
}

export const addAgreement = async (_context, val) => {
  return await axios
    .post('/cms/agreements/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return response.data.data
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const editAgreement = async (_context, val) => {
  return await axios
    .put('/cms/agreements/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return response.data.data
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const deleteAgreement = async (_context, val) => {
  return await axios
    .delete('/cms/agreements/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const getAgreementType = async (context, pagination) => {
  let res = await axios
    .get('/cms/agreements/type', {
      params: pagination
    })
    .then(response => {
      context.commit('getAgreementType', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getAgreementStatus = async (context, pagination) => {
  let res = await axios
    .get('/cms/agreements/status', {
      params: pagination
    })
    .then(response => {
      context.commit('getAgreementStatus', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getHistory = async (context, pagination) => {
  let res = await axios
    .get('/cms/agreements/history', {
      params: pagination
    })
    .then(response => {
      context.commit('getHistory', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addHistory = async (_context, val) => {
  return await axios
    .post('/cms/agreements/history/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const excelAgreement = async (_context, pagination) => {
  let format = pagination.format
  delete pagination.format

  let url = format == 'iso' ? '/cms/agreements/excel' : '/cms/agreements/excel/custom'

  let res = await axios
    .get(url, {
      params: pagination,
      responseType: 'blob'
    })
    .then(response => {
      let fileTitle =
        format == 'iso'
          ? 'FM-SI-SLS-24 Recap Of Agreement Terms Rev 01.xlsx'
          : 'Agreement_Report.xlsx'

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileTitle)
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const recordAgreement = async (_context, val) => {
  return await axios
    .get('/cms/agreements/record/' + val)
    .then(response => {
      return response.data.data
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return null
    })
}

export const uploadAgreement = async (_context, form) => {
  return await axios
    .post('/cms/agreements/upload', form.data, form.config)
    .then(response => {
      return response.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return null
    })
}

export const deleteUpload = async (_context, val) => {
  return await axios
    .delete('/cms/agreements/upload/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}
